import { FlexAligner } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { colors, responsive } from '@/utils';

export const StyledToggleButton = styled.button`
  display: block;
  width: 100%;
  padding: 0;
  background: transparent;
  border: none;
  color: inherit;
  text-align: left;
  cursor: pointer;
  border-radius: ${responsive.radius.small};
  &:hover {
    background-color: ${colors.background.neutral.soft['100']};
  }
`;

export const StyledToggleLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${responsive.spacing.small};
`;

export const StyledChevron = styled.span<{ $expanded: boolean }>`
  display: inline-flex;
  transform: rotate(${({ $expanded }) => ($expanded ? '180deg' : '0deg')});
  transition: transform 0.15s ease;
`;

// Indents the egg-string split under Adult Female.
export const StyledBreakdown = styled(FlexAligner)`
  padding-left: ${responsive.spacing['2xlarge']};
  width: 100%;
`;
